import React from 'react';
import { Button } from '@sandtech-hub-monorepo/ui-kit';
import { ReactComponent as InfoIcon } from '../../../assets/Icons/info-icon.svg';
import { ReactComponent as DeferIcon } from '../../../assets/Icons/defer-icon.svg';
import { ReactComponent as WithdrawIcon } from '../../../assets/Icons/withdraw-icon.svg';

interface Props {
  onDefer: () => void;
  onWithdraw: () => void;
  canWithdraw: boolean | undefined;
  canDefer: boolean | undefined;
}

export const SelectProgramManagementOption = ({
  onDefer,
  onWithdraw,
  canWithdraw,
  canDefer,
}: Props) => {
  return (
    <div className="flex flex-col items-center gap-4 py-8 max-w-full sm:max-w-md mx-auto">
      <div className="p-6 bg-primary/20 rounded-full text-secondary">
        <InfoIcon />
      </div>
      <h2 className="sm:text-2xl text-xl text-center font-semibold">
        Would you like to defer or withdraw from your course?
      </h2>
      <div className="text-center my-4">
        Keep in mind: defer allows to select which course you would like leave
        and resume later, while withdrawing will end it permanently.
      </div>
      <div className="flex gap-4 sm:flex-row flex-col">
        <Button
          variant="outline"
          className="flex gap-2"
          disabled={!canDefer}
          onClick={onDefer}
        >
          Defer
          <DeferIcon />
        </Button>
        <Button
          variant="outlineDestructive"
          className="flex gap-2"
          onClick={onWithdraw}
          disabled={!canWithdraw}
        >
          Withdraw
          <WithdrawIcon />
        </Button>
      </div>
    </div>
  );
};
